function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { addPageClick, removePageClick } from '@demant/wdh';
import jQuery from 'jquery';
import { WDHComponent, onResize } from '../../../../../../wdh-foundation/wdh';
import LinkListApp from './component-link-list';
import TopLink from './component-top-link';
import Navigation from './component-navigation';
import Image from './component-image';
import SearchField from './component-search-field';
import LanguageSelector from './component-language-selector';
var $ = window.jQuery;

var HeaderApp = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderApp, _React$Component);

  var _super = _createSuper(HeaderApp);

  function HeaderApp(props) {
    var _this;

    _classCallCheck(this, HeaderApp);

    _this = _super.call(this, props);
    _this.state = {
      isDesktop: _this.isDesktop(),
      displayMenu: false,
      displaySubMenu: false,
      linkListActive: false,
      prevScrollPos: window.pageYOffset,
      displaySearch: false,
      isSearchResultPage: !!document.querySelector('.search-result-spot'),
      displayCampaignPageHeader: _this.isCampaignPage(),
      showScroll: false
    };
    _this.submenuOutTimeout = null;
    _this.handleMenuClick = _this.handleMenuClick.bind(_assertThisInitialized(_this));
    _this.handleSubMenuClick = _this.handleSubMenuClick.bind(_assertThisInitialized(_this));
    _this.handleSubMenuHide = _this.handleSubMenuHide.bind(_assertThisInitialized(_this));
    _this.handleLinkListClick = _this.handleLinkListClick.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.handleSubMenuOver = _this.handleSubMenuOver.bind(_assertThisInitialized(_this));
    _this.handleSubMenuOut = _this.handleSubMenuOut.bind(_assertThisInitialized(_this));
    _this.showSearchOnDesktop = _this.showSearchOnDesktop.bind(_assertThisInitialized(_this));
    _this.isCampaignPage = _this.isCampaignPage.bind(_assertThisInitialized(_this));
    _this.hideSearch = _this.hideSearch.bind(_assertThisInitialized(_this));
    _this.checkScrollTop = _this.checkScrollTop.bind(_assertThisInitialized(_this));
    _this.scrollTop = _this.scrollTop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HeaderApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      document.querySelector('#header').classList.add('loaded');
      onResize(function () {
        _this2.updateMobileState();

        if (!_this2.state.displayCampaignPageHeader) _this2.calculateHeaderHeight();
      });
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.checkScrollTop);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "calculateHeaderHeight",
    value: function calculateHeaderHeight() {
      var _this3 = this;

      setTimeout(function () {
        var header = document.querySelector('#header');
        var container = header.querySelector(_this3.isDesktop() ? '.header-desktop-top.outer-container' : '.header-mobile-top.outer-container');
        var height = container.offsetHeight;
        header.style.marginBottom = "".concat(height, "px");
        var burgerMenu = document.querySelector('.text-left.expanded');

        if (burgerMenu) {
          burgerMenu.style.top = "".concat(height, "px");
        }
      }, 200);
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return window.matchMedia('(min-width:1025px)').matches;
    }
  }, {
    key: "updateMobileState",
    value: function updateMobileState() {
      this.setState({
        isDesktop: this.isDesktop()
      }, function () {});
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var element = document.querySelector('.header-desktop-top.outer-container') || document.querySelector('.header-mobile-top.outer-container');

      if (!element) {
        return;
      }

      var prevScrollPos = this.state.prevScrollPos;
      var currentScrollPos = window.pageYOffset;

      if (prevScrollPos > currentScrollPos || currentScrollPos === 0) {
        element.style.top = '0';
      } else if (prevScrollPos < currentScrollPos) {
        var height = element.offsetHeight;
        element.style.top = "".concat(-height, "px");
      }

      this.setState({
        prevScrollPos: currentScrollPos
      });
    }
  }, {
    key: "handleLinkListClick",
    value: function handleLinkListClick() {
      this.setState({
        linkListActive: !this.state.linkListActive
      });
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick() {
      this.setState({
        displayMenu: !this.state.displayMenu
      });
    }
  }, {
    key: "handleSubMenuClick",
    value: function handleSubMenuClick(event) {
      event.preventDefault();

      if (event.target === this.state.currentMenu) {
        this.handleSubMenuHide();
        return;
      }

      this.setState({
        displaySubMenu: true,
        currentMenu: event.target
      });
    }
  }, {
    key: "handleSubMenuOver",
    value: function handleSubMenuOver(event) {
      if (this.submenuOutTimeout) {
        clearTimeout(this.submenuOutTimeout);
      }

      if (!this.state.displaySearch) {
        this.setState({
          displaySubMenu: true,
          currentMenu: event.target
        });
      }
    }
  }, {
    key: "handleSubMenuOut",
    value: function handleSubMenuOut() {
      var _this4 = this;

      this.submenuOutTimeout = setTimeout(function () {
        _this4.handleSubMenuHide();
      }, 200);
    }
  }, {
    key: "handleSubMenuHide",
    value: function handleSubMenuHide() {
      var _this5 = this;

      this.setState({
        displaySubMenu: false,
        currentMenu: null
      }, function () {
        document.removeEventListener('click', _this5.handleSubMenuHide);
      });
    }
  }, {
    key: "hideSearch",
    value: function hideSearch() {
      this.setState({
        displaySearch: false
      });
      removePageClick(this.hideSearch);
    }
  }, {
    key: "showSearchOnDesktop",
    value: function showSearchOnDesktop() {
      var _this6 = this;

      this.setState({
        displaySearch: !this.state.displaySearch
      }, function () {
        if (_this6.state.displaySearch) {
          addPageClick(_this6.hideSearch, jQuery('.header-search-field, .ui-autocomplete'));
          document.querySelector(".header-search-field .ui-autocomplete-input").focus();
        }
      });
    }
  }, {
    key: "isCampaignPage",
    value: function isCampaignPage() {
      var campaignPage = document.querySelector('.campaign-page, .campaign-page-inverted, .campaign-page-omf, .campaign-page-omf-inverted');

      if (campaignPage) {
        return true;
      }

      return false;
    }
  }, {
    key: "checkScrollTop",
    value: function checkScrollTop() {
      if (!this.state.showScroll && window.pageYOffset > 300) {
        this.setState({
          showScroll: true
        });
      } else if (this.state.showScroll && window.pageYOffset <= 300) {
        this.setState({
          showScroll: false
        });
      }
    }
  }, {
    key: "scrollTop",
    value: function scrollTop() {
      event.preventDefault();
      $('body,html').animate({
        scrollTop: 0
      }, 700);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, !this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "mobile-section outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-mobile-top outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row-1 outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "image"
      }, /*#__PURE__*/React.createElement(Image, {
        imageData: this.props.settings.image,
        linkData: this.props.settings.imageLink
      })), this.props.settings.linkList && /*#__PURE__*/React.createElement("div", {
        className: "nav-expander right component-ready animate burger-switch ".concat(this.state.displayMenu ? 'nav-expanded' : ''),
        onClick: this.handleMenuClick
      }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)))))), /*#__PURE__*/React.createElement("div", {
        className: "header-mobile-left outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row-1 outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, !this.state.displayCampaignPageHeader ? /*#__PURE__*/React.createElement("div", {
        className: "component navigation"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(CSSTransition, {
        in: this.state.displayMenu,
        timeout: 300,
        classNames: "mobile-transition"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: "dgs-burger-menu text-left ".concat(this.state.displayMenu ? 'expanded' : 'expanded')
      }, !this.state.isSearchResultPage && /*#__PURE__*/React.createElement(SearchField, {
        data: this.props.settings.searchFieldSpot
      }), /*#__PURE__*/React.createElement(Navigation, {
        data: this.props.settings.navigation,
        onClick: this.handleSubMenuClick,
        displaySubMenu: this.state.displaySubMenu,
        currentMenu: this.state.currentMenu,
        isDesktop: this.state.isDesktop
      }), /*#__PURE__*/React.createElement("div", {
        className: "component link-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LinkListApp, {
        data: this.props.settings.linkList
      }))), /*#__PURE__*/React.createElement("div", {
        className: "component language-selector-spot"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LanguageSelector, {
        data: this.props.settings.languageSelector
      })))))))) : null), /*#__PURE__*/React.createElement(React.Fragment, null, this.state.displayCampaignPageHeader ? /*#__PURE__*/React.createElement(CSSTransition, {
        in: this.state.displayMenu,
        timeout: 300,
        classNames: "mobile-transition"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: "dgs-burger-menu text-left ".concat(this.state.displayMenu ? 'expanded' : 'expanded')
      }, /*#__PURE__*/React.createElement("div", {
        className: "component link-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LinkListApp, {
        data: this.props.settings.linkList
      })))))) : null)))))), this.state.isDesktop && /*#__PURE__*/React.createElement("div", {
        className: "desktop-section outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header-desktop-top outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, !this.state.displayCampaignPageHeader && /*#__PURE__*/React.createElement("div", {
        className: "row-1 outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, this.props.settings.languageSelector && /*#__PURE__*/React.createElement("div", {
        className: "component language-selector-spot"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LanguageSelector, {
        data: this.props.settings.languageSelector,
        isDesktop: this.state.isDesktop
      }))), /*#__PURE__*/React.createElement("div", {
        className: "component link-list ".concat(this.state.linkListActive ? 'active-bold' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LinkListApp, {
        data: this.props.settings.linkList,
        onHandleClick: this.handleLinkListClick
      }))))), /*#__PURE__*/React.createElement("div", {
        className: "row-2 outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component image"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, this.state.displayCampaignPageInverted ? /*#__PURE__*/React.createElement(InvertedImage, {
        linkData: this.props.settings.imageLink
      }) : /*#__PURE__*/React.createElement(Image, {
        imageData: this.props.settings.image,
        linkData: this.props.settings.imageLink
      }))), /*#__PURE__*/React.createElement("div", {
        className: "component link"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(TopLink, {
        className: "cd-top ".concat(this.state.showScroll ? 'cd-is-visible' : ''),
        anchorText: "Top",
        onHandleClick: this.scrollTop
      }))), !this.state.displayCampaignPageHeader ? /*#__PURE__*/React.createElement("div", {
        className: "component navigation"
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "dgs-mega-menu ".concat(this.state.displayMenu ? 'expanded' : '')
      }, /*#__PURE__*/React.createElement(Navigation, {
        data: this.props.settings.navigation,
        onMouseOver: this.handleSubMenuOver,
        onFocus: this.handleSubMenuOver,
        onMouseOut: this.handleSubMenuOut,
        onBlur: this.handleSubMenuOut,
        displaySubMenu: this.state.displaySubMenu,
        currentMenu: this.state.currentMenu,
        isDesktop: this.state.isDesktop
      }), !this.state.isSearchResultPage && /*#__PURE__*/React.createElement("div", {
        className: "desktop-search-icon",
        onClick: this.showSearchOnDesktop
      })))) : null, this.state.displayCampaignPageHeader && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "component link-list ".concat(this.state.linkListActive ? 'active-bold' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "component-content"
      }, /*#__PURE__*/React.createElement(LinkListApp, {
        data: this.props.settings.linkList,
        onHandleClick: this.handleLinkListClick
      }))))))))), this.state.displaySearch && /*#__PURE__*/React.createElement("div", {
        className: "desktop-search"
      }, /*#__PURE__*/React.createElement(SearchField, {
        data: this.props.settings.searchFieldSpot
      }))));
    }
  }]);

  return HeaderApp;
}(React.Component);

export default HeaderApp;